import {CYRILLIC_CODE_REGEXP} from 'modules/brands/constants';
import {IBrand} from 'modules/brands/models';

export const extractBrandCodeFromPath = (path: string): string => {
    const segments = path.split('/').filter(Boolean);
    return segments[1] || '';
};

export const findBrandsByFirstLetter = (list: IBrand[], letter?: string) =>
    letter
        ? list.filter((brand) => {
              return brand.title.charAt(0).toLowerCase() === letter.toLowerCase();
          })
        : list;

export const filterBrandsByCyrillicWords = (brands: IBrand[]) =>
    brands.filter((brand) => {
        return brand.title.charAt(0).toLowerCase().match(CYRILLIC_CODE_REGEXP);
    });
